import clsx from 'clsx';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import DrawerSkeleton from '..';
import { convertIntoDate } from '../../Helpers';
import Dropdown from '../../Components/UI/Dropdown';
import { Input } from '../../Components/UI/Input';
import Phone from '../../Components/UI/Phone';
import { createPatientSchema } from '../../Schema';
import { dateOptions, gender } from '../../data';
import DrawerHeader from '../DrawerHeader';
import Button from '../../Components/UI/Button';
import CreateAppointmentDetailDrawer from '../ScheduleDrawer/CreateAppointmentDetailDrawer';
import classes from './CreatePatientAndAppointment.module.css';
const initialValues = {
  countryCode: '',
  fullName: '',
  cellNumber: '',
  email: '',
  gender: null,
  age: '',
  isOpd: true,
  appliedFees: [],
  emrNo: '',
  ageType: { label: 'Year(s)', value: 'Yrs' }
};

const formatDateUnit = (date) => {
  if (date === 'Year(s)') return 'Yrs';
  else if (date === 'Month(s)') return 'Mon';
  else if (date === 'Day(s)') return 'Day';
};
const CreatePatientAndAppointmentDrawer = ({
  show,
  setShow,
  onSubmit,
  cellNumber,
  setShow2,
  setPrevDrawerState,
  data = null
}) => {
  const [isDataLoaded, setIsDataLoaded] = useState(false); // New state to track if data has been set
  const [showAppointmentDrawer, setShowAppointmentDrawer] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  //toggle appointment drawer here
  const toggleAppointmentDrawer = () => {
    setShowAppointmentDrawer((current) => !current);
  };
  const formik = useFormik({
    initialValues,
    validationSchema: createPatientSchema,
    onSubmit: (values, { resetForm }) => {
      const params = {
        ...values,

        // ...(data && { patientId: data?.id }),
        cellNumber: values?.cellNumber?.slice(2),
        countryCode: `+${values?.cellNumber?.slice(0, 2)}`,
        email: values?.email,
        gender: values?.gender?.value,
        dateOfBirth: convertIntoDate(values?.age, values?.ageType?.value),
        patientName: values?.fullName
      };

      setSelectedItem(params);
      setShow();
      //   open the appointment drawer
      toggleAppointmentDrawer();
    }
  });
  const {
    touched,
    errors,
    values,
    handleSubmit,
    setValues,
    resetForm,
    setFieldValue,
    setFieldTouched,
    isValid,
    dirty
  } = formik;
  const handleChangeWithTouch = (field, value) => {
    setFieldValue(field, value);
    setFieldTouched(field, true, false); // Mark field as touched manually
  };
  useEffect(() => {
    //here cell number can be number or string don't confuse by name
    //Here we use show for checking either create patient is show or not bcz this component always mount
    if (show) {
      if (cellNumber && !data) {
        // debugger;

        if (!isNaN(parseInt(cellNumber))) {
          setValues({
            cellNumber
          });
        } else if (typeof cellNumber === 'string') {
          setValues({
            fullName: cellNumber
          });
        }

        return;
      } else if (data) {
        setValues({
          cellNumber: data?.cellNumber?.slice(1),
          fullName: data?.patientName,
          gender: gender?.find((ele) => ele?.label === data?.gender),
          age: +data?.age?.split(' ')[0],
          emrNo: data?.emrNo,

          ageType: dateOptions?.find(
            (ele) => ele?.value === formatDateUnit(data?.age?.split(' ')[1])
          )
        });
        setIsDataLoaded(true); // Mark data as loaded
        return;
      } else {
        // resetForm({ values: { ...initialValues, appliedFees: values.appliedFees } });
      }
    }
  }, [data, cellNumber, setValues, show]);
  return (
    <>
      <DrawerSkeleton
        show={show}
        setShow={() => {
          setPrevDrawerState && setPrevDrawerState();
          setShow();
          setValues(initialValues);
          resetForm();
        }}>
        <form className={classes.form} onSubmit={handleSubmit}>
          <div className={classes.parentWrapper}>
            <DrawerHeader
              title={`Create Patient`}
              setShow={() => {
                resetForm({ values: { ...initialValues, appliedFees: values.appliedFees } });
                setShow();
              }}
              setShow2={() => {
                // resetForm({ values: { ...initialValues, appliedFees: values.appliedFees } });
                setShow2();
              }}
            />
            <div className={clsx(classes.wrapper, 'scrollbar1')}>
              <Row className={clsx(classes.grid)}>
                <Col xs={12}>
                  <Phone
                    id={'create-patient-cellNumber'}
                    name="Signup-cellNumber"
                    placeholder={'+92 XXX XXXXXXX'}
                    value={values.cellNumber}
                    onChange={(value) => handleChangeWithTouch('cellNumber', value)}
                    onBlur={() => setFieldTouched('cellNumber', true)} // Ensure touched state on blur
                    className={classes['mb-15']}
                    errorText={touched?.cellNumber && errors?.cellNumber} // Show error if touched
                    disabled={data}
                  />
                </Col>
                {/* nested grid */}
                <Col md={12}>
                  <Row className={classes.nestedRow}>
                    <Col xs={12} sm={12}>
                      <Input
                        id={'create-patient-fullname-name01'}
                        placeholder="Enter Full Name"
                        label={'Name'}
                        value={values?.fullName}
                        setter={(e) => handleChangeWithTouch('fullName', e)}
                        errorText={touched?.fullName && errors?.fullName}
                        disabled={data}
                      />
                    </Col>
                    {/* <Col xs={12} sm={6}>
                      <Input
                        id={'create-patient-last-name01'}
                        placeholder="Enter Last Name"
                        label={'Last Name'}
                        value={values?.lastName}
                        setter={(e) => handleChangeWithTouch('lastName', e)}
                        errorText={touched?.lastName && errors?.lastName}
                        disabled={data}
                      />
                    </Col> */}
                  </Row>
                </Col>
                {/* nested grid */}
                <Col md={12}>
                  <Row className={classes.nestedRow}>
                    <Col xs={12} sm={6}>
                      <Dropdown
                        id={'create-patient-gender-02'}
                        placeholder="Gender"
                        label={'Gender'}
                        onBlur={() => setFieldTouched('gender', true)}
                        value={values?.gender}
                        options={gender}
                        setter={(e) => handleChangeWithTouch('gender', e)}
                        errorText={touched?.gender && errors.gender}
                        disabled={data}
                      />
                    </Col>
                    <Col xs={12} sm={6}>
                      <div className={classes.ageGroup}>
                        <Input
                          id={'create-patient-age-0'}
                          type="number"
                          placeholder="Age"
                          label={'Age'}
                          value={values?.age}
                          containerClass={classes.ageInput}
                          setter={(e) => {
                            handleChangeWithTouch('age', e);
                          }}
                          errorText={touched?.age && errors?.age}
                          disabled={data?.age}>
                          <Dropdown
                            value={values?.ageType}
                            setter={(e) => {
                              handleChangeWithTouch('ageType', e);
                            }}
                            disabled={data}
                            placeholder=""
                            parentClass={classes.ageDropdown}
                            options={dateOptions}
                          />
                        </Input>
                      </div>
                    </Col>
                  </Row>
                </Col>

                <Col md={12}>
                  <Input
                    isOptional={true}
                    id={'create-patient-email01'}
                    placeholder="Enter Email"
                    label={'Email'}
                    value={values?.email}
                    setter={(e) => {
                      handleChangeWithTouch('email', e);
                    }}
                    errorText={touched?.email && errors?.email}
                    disabled={data}
                  />
                </Col>
              </Row>
            </div>
            <div className={classes.bottomAction}>
              <Button
                label={'Close'}
                variants="secondary"
                onClick={() => {
                  setPrevDrawerState && setPrevDrawerState();
                  resetForm({ values: { ...initialValues, appliedFees: values.appliedFees } });
                  setShow(); // Close the drawer
                }}
              />
              <Button
                type="submit"
                label={`Add Patient`}
                disabled={!(isValid && (dirty || isDataLoaded))} // Enable if valid and either dirty or data is loaded
              />
            </div>
          </div>
        </form>
      </DrawerSkeleton>
      {/* for Appointment drawer  */}
      <CreateAppointmentDetailDrawer
        show={showAppointmentDrawer}
        setShow={() => {
          toggleAppointmentDrawer();
        }}
        onClearPrev={() => {
          resetForm();
        }}
        setShow2={setShow}
        data={{
          ...selectedItem,
          patientName: selectedItem?.fullName,
          age: `${selectedItem?.age} ${selectedItem?.ageType?.label}`
        }}
        createPatient={true}
      />
    </>
  );
};

export default CreatePatientAndAppointmentDrawer;
